export default "__VITE_ASSET__BLuVvYR2__"